import { Ref } from 'vue';
import { Season } from '../api';

export function validateSeasonName(
  seasonName: string,
  existingSeasons: Season[],
  errorMessage: Ref<string, string>
): boolean {
  if (
    existingSeasons
      .map((season) => {
        return season.description?.trim().toLowerCase();
      })
      .includes(seasonName?.trim().toLowerCase())
  ) {
    errorMessage.value = `A season named "${seasonName}" already exists.`;
    return false;
  }
  errorMessage.value = '';
  return true;
}
